import { ReactNode, FC } from 'react';

type CardGridProps = {
  children: ReactNode;
};

export const CourseCardGrid: FC<CardGridProps> = ({ children }) => {
  return (
    <div
      tabIndex={-1}
      className="lf:grid lf:grid-cols-1 lf:justify-center lf:gap-x-3 lf:gap-y-4 lf:sm:grid-cols-2 lf:lg:grid-cols-4 lf:lg:gap-6"
    >
      {children}
    </div>
  );
};
